module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.column) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "first"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/c0024iakzyd_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[0].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/g00243r2wk7_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[1].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "three"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/a0024l5a58w_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[2].filename))])]), _vm._v(" "), _c('section', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "//shp.qpic.cn/qqvideo_ori/0/b0024xgh79z_360_204/0",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.column[3].filename))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("独家专区")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff5c11e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xcolumn.vue
// module id = 265
// module chunks = 0